import { UserInfoChangeConfig } from '@/store/Constraints';
import { LocalStorageConfig } from '@/components/AppConstants';
import { Axios } from '@/api/Axios';
import { MemberApi } from '@/api/Api';

const LoginStore = {
    state: {
        nicknameData: {
            check: false
        }
    },
    getters: {},
    mutations: {
        [UserInfoChangeConfig.CHANGE_PW_EVENT]: (state, payload) => { // 패스워드 변경

        },
        [UserInfoChangeConfig.CHANGE_NICKNAME_OVERLAP_EVENT]: (state, payload) => { // 닉네임 중복확인
            if (payload.code === '1000') state.nicknameData.check = true;
        },
        [UserInfoChangeConfig.CHANGE_NICKNAME_EVENT]: (state, payload) => { // 닉네임 변경
            // 여기는 처리할 값 없음 (화면에 보여줄 내용 없음)
        },
        [UserInfoChangeConfig.CHANGE_USERINFO_EVENT]: (state, payload) => { // 개인 정보 수정

        },

        [UserInfoChangeConfig.CASH_RECEIPT_EVENT]: (state, payload) => { // 현금 영수증 발급 정보

        },
        [UserInfoChangeConfig.CASH_RECEIPT_CHANGE_EVENT]: (state, payload) => { // 현금 영수증 발급 정보

        },

        [UserInfoChangeConfig.CHANGE_AGREE_EVENT]: (state, payload) => { // 위치정보 사용 동의 

        },
    },
    actions: {
        [UserInfoChangeConfig.CHANGE_PW_EVENT]: (store, payload) => { // 패스워드 변경
            return new Promise((resolve, reject) => {
                this.showLoading(true);
                Axios.post(MemberApi.UPDATE_PWD, payload.params)
                    .then(res => {
                        this.showLoading(false);
                        if (res.code === "0000") {
                            console.log(res);
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        this.showLoading(false);
                        console.log(err);
                        reject(err);
                    })
            });
        },
        [UserInfoChangeConfig.CHANGE_NICKNAME_OVERLAP_EVENT]: (store, payload) => { // 닉네임 중복확인
            return new Promise((resolve, reject) => {});
        },
        [UserInfoChangeConfig.CHANGE_NICKNAME_EVENT]: (store, payload) => { // 닉네임 변경
            return new Promise((resolve, reject) => {});
        },
        [UserInfoChangeConfig.CHANGE_PHONENUM_EVENT]: (store, payload) => { // 휴대폰 번호 변경
            return new Promise((resolve, reject) => {});
        },
        [UserInfoChangeConfig.CHANGE_USERINFO_EVENT]: (store, payload) => { // 개인 정보 수정
            return new Promise((resolve, reject) => {});
        },
        [UserInfoChangeConfig.CASH_RECEIPT_EVENT]: (store, payload) => { // 현금 영수증 발급 정보
            store.commit(UserInfoChangeConfig.CASH_RECEIPT_EVENT, { code: '1000', message: '', type: '아직 결정 안됨', requestNo: '전화번호 또는 사업자 번호' })
        },
        [UserInfoChangeConfig.CASH_RECEIPT_CHANGE_EVENT]: (store, payload) => { // 현금 영수증 발급 정보 변경
            return new Promise((resolve, reject) => {
                this.showLoading(true);
                Axios.post(MemberApi.UPDATE_MEMBER_CASH_RECEIPT, payload.params)
                    .then(res => {
                        this.showLoading(false);
                        if (res.code === "0000") {
                            console.log(res);
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        this.showLoading(false);
                        console.log(err);
                        reject(err);
                    })
            });
        },
        // 위치정보 사용 동의, PUSH 수신 동의, SMM 수신 동의, E-Mail 수신 동의
        [UserInfoChangeConfig.CHANGE_AGREE_EVENT]: (store, payload) => {
            return new Promise((resolve, reject) => {});
        },
        [UserInfoChangeConfig.MEMBER_RETIRE]: (store, payload) => {
            return new Promise((resolve, reject) => {
                this.showLoading(true);
                Axios.post(MemberApi.MEMBER_RETIRE, payload.params)
                    .then(res => {
                        this.showLoading(false);
                        if (res.code === "0000") {
                            console.log(res);
                            resolve(res);
                        }
                    })
                    .catch(err => {
                        this.showLoading(false);
                        console.log(err);
                        reject(err);
                    })
            });
        }
    }
}
export default LoginStore;


// WEBPACK FOOTER //
// ./src/store/member/UserInfoChangeStore.js